import React, { Component } from 'react';

class IPFSDocumentation extends Component {
    render() {
        return (
            <div>
              <p>
                Files for samples, projects, presets, and user profiles
                are all stored using the <a href="https://ipfs.io/">IPFS protocol</a>. You
                can think of IPFS as a world-wide filesystem, where files can be
                copied and hosted on multiple computers-- similar to BitTorrent. 
              </p>
              <p className="sub-header">
                Installing
              </p>
              <p>
                You are encouraged to install <a href="https://github.com/ipfs-shipyard/ipfs-desktop">IPFS</a>. This
                will keep the files you use on your computer, so that you
                can load samples much faster. Also, this gives you peace
                of mind that your files are at least on your computer.
              </p>
              <p className="sub-header">
                Fortifying the Archive
              </p>
              <p>
                Note that, all files copied to your own IPFS instance will get backed
                up on Zequencer servers as well. But there’s no way to guarantee
                that they’ll be there forever (MySpace for example lost 10 years
                of history in 2018).
              </p>
              <p>
                So it’s good to run IPFS on your computer, to fortify the archive.
                The more people do this, the more resilient the archive of
                samples, songs, and presets will be. And you get the plus
                of loading songs quickly from your own machine, while
                possibly helping others looking for files.
              </p>
              <p className="sub-header">
                Downloading Samples
              </p>
              <p>
                In order to download all samples to your computer, go 
                to <a href="http://zequencer.io/download">this page</a> and click
                “Start”. You will need to have IPFS running. This process
                will probably take hours so sit tight, smoke something.
              </p>
            </div>
        );
    }
}

export default IPFSDocumentation;
